import { Pipe, PipeTransform } from '@angular/core';
import { StoreViewModel } from '@models/api.models';

@Pipe({
    name: 'sortFavoriteStore',
    standalone: true
})
export class SortFavoriteStorePipe implements PipeTransform {
    transform(stores: StoreViewModel[] | null, favoriteStoreId?: number | string): StoreViewModel[] {
        if (!stores) {
            return [];
        }

        if (favoriteStoreId) {
            return stores.sort((storeA, storeB): number => {
                if (storeA.storeId === favoriteStoreId) {
                    return -1;
                } else if (storeB.storeId === favoriteStoreId) {
                    return 1;
                } else {
                    return 0;
                }
            });
        }

        return stores || [];
    }
}
